export default __webpack_public_path__ + "static/6-acf0e81a489ddc46261d0db065e907c7.png";